module.exports = __webpack_public_path__ + "static/media/pencil03.c3c210b1.webp";